const React = require('react')

exports.wrapPageElement = function wrapPageElement({ element, props }) {
  const Layout = element.type.Layout ?? React.Fragment
  return React.createElement(Layout, props, element)
}
